import Plus from 'components/shared/Icon/icons/Plus';

import s from './index.module.css';

type CreateOptionProps = {
  value?: string;
};

export function CreateOption(props: CreateOptionProps) {
  return (
    <div className={s.option}>
      <div className={s.iconContainer}>
        <Plus width="2rem" height="2rem" fill="currentColor" />
      </div>

      <div className={s.textWrapper}>
        <span className={s.text}>
          Create
          {!props.value && ' an option'}
        </span>
        {props.value && <span className={s.value}>&quot;{props.value}&quot;</span>}
      </div>
    </div>
  );
}
